import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { projectShape } from '@adsk/bim360-matrix-react-helpers/es/propTypes';
import {
  getOrCreateGlobalContext,
  CONTEXT_NAMES
} from '@adsk/bim360-matrix-react-helpers/es/globalContexts';

const ProjectContext = getOrCreateGlobalContext(CONTEXT_NAMES.ProjectContext);

export const ProjectProvider = ({ project, children }) => (
  <ProjectContext.Provider value={project}>{children}</ProjectContext.Provider>
);

ProjectProvider.propTypes = {
  project: projectShape,
  children: PropTypes.node.isRequired
};

export const ProjectConsumer = ({ children }) => (
  <ProjectContext.Consumer>{contextValue => children(contextValue)}</ProjectContext.Consumer>
);

ProjectConsumer.propTypes = {
  children: PropTypes.func.isRequired
};

export const useProject = () => useContext(ProjectContext);

export default ProjectContext;
